const Tracking = () => {
  return null;
};

export default Tracking;
